import { render, staticRenderFns } from "./AtividadesColaborador.vue?vue&type=template&id=c95336b4"
import script from "./AtividadesColaborador.vue?vue&type=script&lang=js"
export * from "./AtividadesColaborador.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports